const ENDPOINTS = {
  SEARCH_ORDERS: '/',
};

export default ENDPOINTS;